import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft, faTrash, faChevronRight, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function EmailDraftHistory({ onSelectDraft, isOpen, onClose }) {
  const [drafts, setDrafts] = useState([]);

  useEffect(() => {
    if (isOpen) {
      loadDrafts();
    }
  }, [isOpen]);

  const loadDrafts = () => {
    const savedDrafts = JSON.parse(localStorage.getItem("aiEmailDrafts") || "[]");
    setDrafts(savedDrafts);
  };

  const deleteDraft = (index, e) => {
    e.stopPropagation();
    const newDrafts = [...drafts];
    newDrafts.splice(index, 1);
    localStorage.setItem("aiEmailDrafts", JSON.stringify(newDrafts));
    setDrafts(newDrafts);
  };

  const clearAll = () => {
    localStorage.removeItem("aiEmailDrafts");
    setDrafts([]);
  };

  return (
    <div className={`draft-history-panel ${isOpen ? "open" : ""}`}>
      <div className="draft-history-header">
        <h5>
          <FontAwesomeIcon icon={faClockRotateLeft} className="mr-2" /> 
          Draft History
        </h5>
        <button className="close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      <div className="draft-history-body">
        {drafts.length === 0 ? (
          <div className="empty-history">
            <p>No draft history found.</p>
            <small>AI generated emails will be saved here automatically.</small>
          </div>
        ) : (
          <>
            <div className="history-actions mb-3">
              <button className="btn btn-sm btn-outline-danger" onClick={clearAll}>
                Clear All
              </button>
            </div>
            <div className="draft-list">
              {drafts.map((draft, idx) => (
                <div 
                  key={idx} 
                  className="draft-item"
                  onClick={() => {
                    onSelectDraft(draft);
                    onClose();
                  }}
                >
                  <div className="draft-item-header">
                    <span className="badge badge-primary">{draft.purpose}</span>
                    <small className="text-muted">
                      {new Date(draft.timestamp).toLocaleString()}
                    </small>
                  </div>
                  <div className="draft-item-subject mt-2">
                    <strong>Subject:</strong> {draft.subject || "(No Subject)"}
                  </div>
                  <div className="draft-item-preview mt-1 text-muted">
                    {draft.body ? draft.body.substring(0, 60) + "..." : ""}
                  </div>
                  <div className="draft-item-footer mt-2">
                    <button 
                      className="btn btn-sm btn-link text-danger p-0"
                      onClick={(e) => deleteDraft(idx, e)}
                    >
                      <FontAwesomeIcon icon={faTrash} /> Delete
                    </button>
                    <span className="text-primary" style={{ fontSize: "0.85rem" }}>
                      Load Draft <FontAwesomeIcon icon={faChevronRight} />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
